import React from 'react';
import { observer } from 'mobx-react';

const ProctorTypeList = observer(class ProctorTypeList extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.filterProctorTypes = this.filterProctorTypes.bind(this);
  }

  filterProctorTypes(proctorTypeSids) {
    const { proctorTypeList } = this.props.store.SessionStore;

    let proctorTypes = [];

    proctorTypeList.forEach(parentType => {
      parentType.subCategories.forEach(proctorType => {
        if(proctorTypeSids.indexOf(proctorType.sid) > -1) {
          proctorTypes.push(proctorType);
        }
      });
    })

    return proctorTypes;
  }

  render() {
    const proctorTypes = this.filterProctorTypes(this.props.proctorTypes);

    return (
      <ul className="data--comma">
        {proctorTypes.map(proctorType =>
          <li key={proctorType.sid}>
            {proctorType.title}
          </li>
        )}
      </ul>
    )
  }
})

export default ProctorTypeList;



// WEBPACK FOOTER //
// ./src/app/components/Modules/ProctorTypeList.js